import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ReviewForm } from "./ReviewForm";
import { useSubmitReview, ReviewFormData } from "@/hooks/useSubmitReview";
import { useOptimizedAuth } from "@/hooks/useOptimizedAuth";

interface WriteReviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  productId: string;
  productName: string;
}

export const WriteReviewDialog = ({
  open,
  onOpenChange,
  productId,
  productName,
}: WriteReviewDialogProps) => {
  const { user } = useOptimizedAuth();
  const { mutate: submitReview, isPending } = useSubmitReview();

  const handleSubmit = (data: ReviewFormData) => {
    if (!user) {
      return;
    }
    
    submitReview(
      {
        productId,
        data,
        userId: user.id,
      },
      {
        onSuccess: () => {
          onOpenChange(false);
        },
      }
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Write a Review</DialogTitle>
          <DialogDescription>
            Share your experience with {productName}
          </DialogDescription>
        </DialogHeader>
        {!user ? (
          <p className="text-muted-foreground">You must be logged in to submit a review.</p>
        ) : (
          <ReviewForm
            onSubmit={handleSubmit}
            isLoading={isPending}
            isGuest={false}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
